<mad-breadcrumb [breadcrumbs]="breadcrumbs"></mad-breadcrumb>

<mad-breadcrumb [breadcrumbs]="breadcrumbs" [showCopy]="true" (copy)="copied()"></mad-breadcrumb>
